module.exports = __webpack_public_path__ + "img/Chevron-Up_16px_Icon-Dark.766adf7f.svg";